import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import { TreeComponent } from 'angular-tree-component';
import { HhgScopeService } from '../../services/hhg-scope/hhg-scope.service';
import { Carrier, Scope, StateCountry } from 'src/app/shared/common-components/common-structure';
import * as _ from 'lodash';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';
import { api_error } from '../../shared/common-components/AppConstants';
import * as FileSaver from 'file-saver';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DownloadFileResponse } from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import { ConfirmationModalComponent } from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'app-hhg-carrier-scope',
    templateUrl: './hhg-carrier-scope.component.html',
    styleUrls: ['./hhg-carrier-scope.component.css'],
    standalone: false
})
export class HhgCarrierScopeComponent implements OnInit {
    /*
        This screen allows CRUD for carrier scope (orig/dest pairs).

    */


    // get references to DOM objects for tree structures
   // @ViewChild('originTreeComponent', {static: true}) originTreeComponent: TreeComponent;
    //@ViewChild('destinationTreeComponent', {static: true}) destinationTreeComponent: TreeComponent;

    // DATA (to come from SERVICE layer)
    // stateCountries: types.stateCountry[] = data.stateCountries;
    // countries: types.stateCountry[] = _.filter(this.stateCountries, {'type': 'C'});
    // states: types.stateCountry[] = _.filter(this.stateCountries, {'type': 'S'});
    stateCountries: StateCountry[];
    countries: StateCountry[];
    states: StateCountry[];
    serviceAreas: StateCountry[];

    scopes: Scope[];

    // internal tree structures (array of objects)
    emptyOriginTree: any[] = [];
    emptyDestinationTree: any[] = [];
    originTree: any[] = [];
    destinationTree: any[] = [];

    // symbolic constants
    intraIndex = 0;
    interIndex = 1;
    intlIndex = 2;

    scopeType: string;
    modalRef: BsModalRef;
    exportDisabled: boolean;

    originStr = 'Origin';
    destinationStr = 'Destination';

    intraStr = 'Intrastate';
    intraCode = 'A';
    interStr = 'Interstate';
    interCode = 'R';
    intlStr = 'International';
    intlCode = 'I';

    // hold the NEXT ID of each list
    nextOriginId = 1;
    nextDestinationId = 1;

    scope: Scope[];
    activeCarrier: Carrier;

    // tree control's options
    options = {};

    // show / hide 3 'add' sections for origin and destination
    showAdd = true;

    // formGroup
    selectionGroup: UntypedFormGroup;
    originGroup: UntypedFormGroup;
    destinationGroup: UntypedFormGroup;

    // internal screen state
    screenState: any = {
        state: '',
        text: '',

        showingOrigins: 'Showing all origins for destination: ',
        showingDestinations: 'Showing all destinations for origin: ',
        showingAll: 'Showing all origins and destinations.',

        showAll: 'SHOWALL',
        showDest: 'SHOWDEST',
        showOrigin: 'SHOWORIG',

        carrierLoaded: false,
        statesLoaded: false,
        scopeLoaded: false,

        partialAdd: false,
        addOrigin: null,
        addDestination: null,

        selectedOrigin: null,
        selectedDestination: null,
        selectedTypeIndex: 0,

        success: '',
        failure: '',


    };

    messages: any = {
        success: '',
        failure: '',
    };

    private tmssloader;

    constructor(
        private fb: UntypedFormBuilder,
        private hhgScopeService: HhgScopeService,
        private alert: AlertService,
        private loader: LoadingService,
        private modalService: BsModalService,
        private route: ActivatedRoute, ) {

        this.tmssloader = this.loader;
        /* this.selectionGroup = this.fb.group({
            scopeTypeInput: new FormControl(''),
        }); */
        this.originGroup = this.fb.group({
            originInput: new UntypedFormControl(),
            originAddServiceToo: new UntypedFormControl(),
        });
        this.destinationGroup = this.fb.group({
            destinationInput: new UntypedFormControl(),
        });


    }

    /*
        This initialize function gets carrier and state/country data
    */
    ngOnInit() {
        this.tmssloader.show();
        this.exportDisabled = true;
        this.route.queryParams.subscribe(params => {
            console.log("got router parameters", params);
            let paramCarrierId: number;
            if (params.carrierId) {
                paramCarrierId = params.carrierId;
            }

            this.hhgScopeService.getAllStateCountries().subscribe(data => {
                console.log('got state-country records', data);
                this.stateCountries = (data as StateCountry[]);
                this.countries = _.filter(this.stateCountries, { 'stateCountryType': 'Country' });
                this.states = _.filter(this.stateCountries, { 'stateCountryType': 'State' });
                this.serviceAreas = _.filter(this.stateCountries, { 'stateCountryType': 'Service Area' });
                this.stateCountries = _.sortBy(this.stateCountries, ['type', 'code']);

                this.screenState.statesLoaded = true;
                this.checkLoad();
                //this.checkLoad('Interstate');
            });

            this.hhgScopeService.getCarrier(paramCarrierId).subscribe(data => {
                console.log("got carrier record", data);
                this.activeCarrier = (data as Carrier);
                this.screenState.carrierLoaded = true;
                this.tmssloader.show();
                this.hhgScopeService.getCarrierScope(this.activeCarrier.carrierId).subscribe(s => {
                   // this.scope = (s as Scope[]);
                    this.screenState.scopeLoaded = true;
                    this.checkLoad();
                    //this.checkLoad('Interstate');
                    this.tmssloader.hide();
                });
            })
        }, error => {
            this.loader.hide();
            console.log('There was an error retrieving Data');
            this.alert.error('There was an error retrieving Data');
          }
        );

    }


    // navigation back to carrier approval screen
    goBack() {
        document.location.href = '/carrierapproval?carrierId=' + this.activeCarrier.carrierId;
    }

	/*
		This function empties the trees by cloning
		a tree with only three nodes (intra, inter, intl)

	*/

    emptyTree(target?: string) {
        if (!target) { target = 'both'; }
        switch (target) {
            case 'origin':
                this.originTree = this.cloneArrayOfObjects(this.emptyOriginTree);
                break;
            case 'destination':
                this.destinationTree = this.cloneArrayOfObjects(this.emptyDestinationTree);
                break;
            default:
                // set origin and destination node trees, and their NEXT id counters
                this.originTree = this.cloneArrayOfObjects(this.emptyOriginTree);
                this.destinationTree = this.cloneArrayOfObjects(this.emptyDestinationTree);
        }
    }

	/*
		This function makes sure all carriers and state/country records are loaded
		before loading the typeahead lists and
		selecting a default carrier


	*/
    checkLoad() {
        if (
            this.screenState.carrierLoaded &&
            this.screenState.statesLoaded &&
            this.screenState.scopeLoaded) {
            this.tmssloader.hide();
            console.log('all objects loaded. Initializing trees.');

            // initial setup of 'empty' array of nodes
            this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.intraStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
            this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.interStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
            this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.intlStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });

            this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.intraStr, children: [], showAddInput: false, list: _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName), serviceAreaCount: 0, showPlus: false });
            this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.interStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
            this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.intlStr, children: [], showAddInput: false, list: _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName), serviceAreaCount: 0, showPlus: false });

            this.emptyOriginTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
            this.emptyOriginTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
            this.emptyOriginTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);
            this.emptyDestinationTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
            this.emptyDestinationTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
            this.emptyDestinationTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);

            this.screenState.state = this.screenState.showAll;
            this.screenState.text = this.screenState.showingAll;

            this.emptyTree('both');
            this.loadTree();
            this.tmssloader.hide();
        }
    }

    /* checkLoad(value: string) {
        if (
            this.screenState.carrierLoaded &&
            this.screenState.statesLoaded &&
            this.screenState.scopeLoaded) {
            this.tmssloader.hide();
            console.log('all objects loaded. Initializing trees.');

            if (this.selectionGroup.get('scopeTypeInput').value === 'Interstate') {
                this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.interStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
                this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.interStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
                // initial setup of 'empty' array of nodes
                this.emptyOriginTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);

                this.screenState.state = this.screenState.showAll;
                this.screenState.text = this.screenState.showingAll;

                this.emptyTree('both');
                this.loadTree();
                this.tmssloader.hide();
            } else if (this.selectionGroup.get('scopeTypeInput').value === 'Intrastate') {
                this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.intraStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
                this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.intraStr, children: [], showAddInput: false, list: _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName), serviceAreaCount: 0, showPlus: false });
                // initial setup of 'empty' array of nodes
                this.emptyOriginTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);

                this.screenState.state = this.screenState.showAll;
                this.screenState.text = this.screenState.showingAll;

                this.emptyTree('both');
                this.loadTree();
                this.tmssloader.hide();
            } else if (this.selectionGroup.get('scopeTypeInput').value === 'International') {
                this.emptyOriginTree.push({ id: this.nextOriginId++, name: this.intlStr, children: [], showAddInput: false, list: [], serviceAreaCount: 0, showPlus: false });
                this.emptyDestinationTree.push({ id: this.nextDestinationId++, name: this.intlStr, children: [], showAddInput: false, list: _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName), serviceAreaCount: 0, showPlus: false });
                // initial setup of 'empty' array of nodes
                this.emptyOriginTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyOriginTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[0].list = _.map(this.states, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[1].list = _.map(this.serviceAreas, s => s.stateCountryCode + ' - ' + s.stateCountryName);
                this.emptyDestinationTree[2].list = _.map(this.stateCountries, s => s.stateCountryCode + ' - ' + s.stateCountryName);

                this.screenState.state = this.screenState.showAll;
                this.screenState.text = this.screenState.showingAll;

                this.emptyTree('both');
                this.loadTree();
                this.tmssloader.hide();
            }
        }
    } */

    test(val: string) {
        if (val === 'Interstate') {
            console.log('selected is Interstate');
        } else if (val === 'Intrastate') {
            console.log('selected is Intrastate');
        } else if (val === 'International') {
            console.log('selected is International');
        } else {
            console.log("Nothing is working")
        }
    }


	/*

		This function sets a message (success or failure) for 10 seconds
	*/
    setMessage(message: string, type: string) {
        this.screenState.success = '';
        this.screenState.failure = '';
        switch (type) {
            case 'success':
                this.screenState.success = message;
                break;
            case 'failure':
                this.screenState.failure = message;
                break;
            default:

        }

        setTimeout(() => {
            this.screenState.success = '';
            this.screenState.failure = '';
        }, 10000);
    }

	/*

		This function is triggered when the user clicks the 'add' button on the
		add origin / destination

		First, the string in the text input is checked and the state country record found

		Then, the node is added to the tree (if it doesn't already exist) and
		sent to the DB as new SCOPE record if matching opposite is selected.

	*/
    add(target, node) {
        // console.log("adding", target, node);
        const indexParam = node.index;
        let toAdd;
        if (target === this.originStr) { toAdd = this.originGroup.get('originInput').value; }
        if (target === this.destinationStr) { toAdd = this.destinationGroup.get('destinationInput').value; }

        let scc = _.find(this.stateCountries, { stateCountryName: toAdd });
        if (!scc) {
            scc = _.find(this.serviceAreas, { stateCountryCode: toAdd.substr(0, 4) });
        }
        if (!scc) {
            console.log('add not found in statecountries nor serviceareas');
        } else {
            // console.log('adding - scc', scc);
            let existing;
            switch (target) {
                case this.originStr:
                    existing = _.find(this.originTree[indexParam].children, (v, k) => v.code === scc.stateCountryCode);
                    if (!existing) {
                        this.screenState.addOrigin = scc;
                        if (this.screenState.selectedDestination || node.index === this.intraIndex) {
                            console.log('adding - there IS a selected Destination (or INTRASTATE) - send new scope record to db');
                            const r = new Scope();
                            r.scopeId = null;
                            r.carrierId = this.activeCarrier.carrierId;
                            r.originId = scc.stateCountryId;
                            r.destinationId =
                                (node.index === this.intraIndex ? scc.stateCountryId : this.screenState.selectedDestination.data.scRecord.stateCountryId);
                            r.scopeType = node.data.name;
                            this.scopeType = node.data.name;
                            r.updateProgram = 'hhgScope';
                            const toSend: Scope[] = [];
                            toSend.push(r);

                            this.tmssloader.show();
                            // this.hhgScopeService.addCarrierScope(toSend).subscribe(data => {
                            //     this.tmssloader.hide();
                            //     const temp: Scope[] = (data as Scope[]);
                            //     let message = '';
                            //     _.forEach(temp, t => {
                            //         console.log(t);
                            //         message = message + 'Scope record added from ' + t.stateCountryOrigDetails.stateCountryName + ' to ' + t.stateCountryDestDetails.stateCountryName + '.';
                            //         this.scope.push(t);
                            //     });
                            //     this.setMessage(message, 'success');
                            //     const parentId = node.parent.id;
                            //     if (node.index === this.intraIndex) {
                            //         this.loadTree();
                            //         this.select(this.originTreeComponent.treeModel.getNodeById(this.intraIndex + 1), 'origin');
                            //     } else {
                            //         this.loadTree(this.screenState.selectedDestination.data, 'destination');
                            //     }
                            //     this.originTree[this.screenState.selectedTypeIndex].showPlus = true;
                            // }, error => {
                            //     this.alert.error(api_error);
                            // });
                        } else {
                            console.log('adding - there IS NO selected Destination - add new origin and SELECT it (show no destinations)');

                            this.originTree[indexParam].children.push({
                                id: this.nextOriginId++,
                                name: scc.stateCountryName,
                                children: [],
                                code: scc.stateCountryCode,
                                showAddInput: false,
                                list: [],
                                locationType: indexParam,
                                showPlus: false,
                                showMinus: true,
                                scRecord: scc,
                            });
                            // this.originTreeComponent.treeModel.update();
                            // this.select(this.originTreeComponent.treeModel.getNodeById(this.nextOriginId - 1), 'origin');

                        }

                    } else {
                        console.log('scc already exists as an origin');
                        // this.originTreeComponent.treeModel.getNodeById(existing.id).setIsActive(true);
                    }
                    // this.originTree
                    break;
                case this.destinationStr:
                    existing = _.find(this.destinationTree[indexParam].children, (v, k) => v.code === scc.stateCountryCode);
                    if (!existing) {
                        this.screenState.addDestination = scc;
                        if (this.screenState.selectedOrigin) {
                            console.log('adding - there IS a selected Origin - send new scope record to db');
                            const r = new Scope();
                            r.scopeId = null;
                            r.carrierId = this.activeCarrier.carrierId;
                            r.originId = this.screenState.selectedOrigin.data.scRecord.stateCountryId;
                            r.destinationId = scc.stateCountryId;
                            r.scopeType = node.data.name;
                            r.updateProgram = 'hhgScope';
                            const toSend: Scope[] = [];
                            toSend.push(r);

                            this.tmssloader.show();
                            // this.hhgScopeService.addCarrierScope(toSend).subscribe(data => {
                            //     this.tmssloader.hide();
                            //     const temp: Scope[] = (data as Scope[]);
                            //     let message = '';
                            //     _.forEach(temp, t => {
                            //         message = message + 'Scope record added from ' + t.stateCountryOrigDetails.stateCountryName + ' to ' + t.stateCountryDestDetails.stateCountryName + '.';
                            //         this.scope.push(t);
                            //     });
                            //     this.setMessage(message, 'success');
                            //     const parentId = node.parent.id;
                            //     this.loadTree(this.screenState.selectedOrigin.data, 'origin');
                            //     this.destinationTree[this.screenState.selectedTypeIndex].showPlus = true;
                            // });
                        } else {
                            console.log('adding - there IS NO selected Origin - add new destination and SELECT it (show no origins)');

                            this.destinationTree[indexParam].children.push({
                                id: this.nextDestinationId++,
                                name: scc.stateCountryName,
                                children: [],
                                code: scc.stateCountryCode,
                                showAddInput: false,
                                list: [],
                                locationType: indexParam,
                                showPlus: false,
                                showMinus: true,
                                scRecord: scc,
                            });
                            // this.destinationTreeComponent.treeModel.update();
                            // this.select(this.destinationTreeComponent.treeModel.getNodeById(this.nextDestinationId - 1), 'destination');

                        }
                    } else {
                        console.log('scc already exists as a destination');
                        // this.destinationTreeComponent.treeModel.getNodeById(existing.id).setIsActive(true);
                    }
                    break;
                default:
            }

        }
    }

	/*

		This function adds a node
			to target (origin / destination)
			index (must be unique within origin / dest)
			stateCountryCodeParam (actually scope record)
			showMinus (whether or not to show munis icon next to name)


	*/
    addToTree(target, indexParam, stateCountryCodeParam: Scope, showMinus) {
        let tempNodes;
        switch (target) {
            case this.originStr:
                this.originTree[indexParam].children.push({
                    id: this.nextOriginId++,
                    name: stateCountryCodeParam.stateCountryOrigDetails.stateCountryName,
                    children: [],
                    code: stateCountryCodeParam.stateCountryOrigDetails.stateCountryCode,
                    showAddInput: false,
                    list: [],
                    locationType: indexParam,
                    showPlus: false,
                    showMinus: showMinus,
                    scRecord: stateCountryCodeParam.stateCountryOrigDetails,
                });
                //tempNodes = this.originTreeComponent.treeModel.expandedNodes;
                if (tempNodes.length > 0) { tempNodes[0].expand(); }
                break;
            case this.destinationStr:
                this.destinationTree[indexParam].children.push({
                    id: this.nextDestinationId++,
                    name: stateCountryCodeParam.stateCountryDestDetails.stateCountryName,
                    children: [],
                    code: stateCountryCodeParam.stateCountryDestDetails.stateCountryCode,
                    showAddInput: false,
                    list: [],
                    locationType: indexParam,
                    showPlus: false,
                    showMinus: showMinus,
                    scRecord: stateCountryCodeParam.stateCountryDestDetails,
                });
               // tempNodes = this.destinationTreeComponent.treeModel.expandedNodes;
                if (tempNodes.length > 0) { tempNodes[0].expand(); }

                break;
            default:
        }
    }


    /*
    	This function unconditionally removes all minuses

    */
    removeMinuses() {
        _.forEach(this.originTree, r => {
            _.forEach(r.children, c => {
                c.showMinus = false;
            });
        });
        // this.originTreeComponent.treeModel.update();
        _.forEach(this.destinationTree, r => {
            _.forEach(r.children, c => {
                c.showMinus = false;
            });
        });
        // this.destinationTreeComponent.treeModel.update();
    }

	/*

		This function is triggered when the user clicks a node

		ROOT (intra, inter, intl), screenmode = SHOWALL, expand both

		CHILD (screenmode = SHOWDEST or SHOWORIG for that value)
	*/
    select(node: any, target: string) {
        console.log(node.data.name);
        this.exportDisabled = false;
        this.scopeType = node.data.name;
        const scopeParent = node.parent;
        if (node.isRoot) {
            console.log('root clicked', target, node);
            this.screenState.state = 'SHOWALL';
            this.screenState.text = this.screenState.showingAll;
            this.screenState.selectedOrigin = null;
            this.screenState.selectedDestination = null;
            this.loadTree();

            if (target === 'destination') {
                this.originTree[node.index].showPlus = false;
                this.destinationTree[node.index].showPlus = true;
            } else {
                this.originTree[node.index].showPlus = true;
                this.destinationTree[node.index].showPlus = false;
            }
            //this.originTreeComponent.treeModel.getNodeById(node.id).expand();
           // this.destinationTreeComponent.treeModel.getNodeById(node.id).expand();

        } else {
            this.removeMinuses();
            if (target === 'destination') {
                console.log('destnation clicked - show origins');
                this.screenState.state = this.screenState.showDest;
                this.screenState.text = this.screenState.showingOrigins + node.data.name;
                //this.originTreeComponent.treeModel.collapseAll();
                node.setIsActive(true);
                this.loadTree(node.data, target);
                this.originTree[scopeParent.index].showPlus = true;
                this.destinationTree[scopeParent.index].showPlus = false;
                this.screenState.selectedOrigin = null;
                this.screenState.selectedDestination = node;
                this.screenState.selectedTypeIndex = scopeParent.index;
                node.focus();
            } else {
                // target === origin
                console.log('origin clicked - show destinations');
                this.screenState.state = this.screenState.showOrig;
                this.screenState.text = this.screenState.showingDestinations + node.data.name;
               // this.destinationTreeComponent.treeModel.collapseAll();
                this.loadTree(node.data, target);
                this.originTree[scopeParent.index].showPlus = false;
                this.destinationTree[scopeParent.index].showPlus = true;
                this.screenState.selectedOrigin = node;
                this.screenState.selectedTypeIndex = scopeParent.index;
                this.screenState.selectedDestination = null;
                node.focus();
            }
           // this.originTreeComponent.treeModel.getNodeById(scopeParent.id).expand();
            //this.destinationTreeComponent.treeModel.getNodeById(scopeParent.id).expand();
        }
        // console.log("this.originTree[scopeParent.index].showPlus", this.originTree[scopeParent.index].showPlus);
        // console.log("this.destinationTree[scopeParent.index].showPlus", this.destinationTree[scopeParent.index].showPlus);
        // console.log('updating')
      //  this.originTreeComponent.treeModel.update();
       // this.destinationTreeComponent.treeModel.update();

    }

	/*
		This function resets the screen COMPONENT trees

		The carrier's scope is separated and grouped into
		orig / dest, intra / inter / intl
		and added as children

		Then the COMPONENT is updated to show the new values



	*/
    loadTree(node?: any, targetParam?: string) {
        // if EITHER target or statCountryCode data are missing, simply load both source and destinations
        let target: string = (!targetParam ? 'both' : targetParam);
        let c = '';
        if (!node) {
            target = 'both';
        } else {
            console.log('setting c - node.scRecord.stateCountryId', node);
            c = node.scRecord.stateCountryId;
        }

        const x = _.groupBy(this.scope, 'scopeType');
        const y = {
            'Intrastate': {
                'origins': _.groupBy(x[this.intraStr], 'originId'),
                'destinations': _.groupBy(x[this.intraStr], 'destinationId')
            },
            'Interstate': {
                'origins': _.groupBy(x[this.interStr], 'originId'),
                'destinations': _.groupBy(x[this.interStr], 'destinationId')
            },
            'International': {
                'origins': _.groupBy(x[this.intlStr], 'originId'),
                'destinations': _.groupBy(x[this.intlStr], 'destinationId')
            }
        };

        // close all 'add' textboxes if open
        _.forEach(this.originTree, t => {
            t.showAddInput = false;
        });
       // this.originTreeComponent.treeModel.update();
        _.forEach(this.destinationTree, t => {
            t.showAddInput = false;
        });
        // this.destinationTreeComponent.treeModel.getNodeById(1).hide();
        //this.destinationTreeComponent.treeModel.update();

        switch (target) {
            case 'origin':
                // console.log("in loadtree - origin - switch");
                this.emptyTree('destination');
                if (node.locationType === this.intraIndex) {
                    _.forEach(y[this.intraStr]['origins'][c], dest => { this.addToTree(this.destinationStr, this.intraIndex, dest, true); });
                }
                if (node.locationType === this.interIndex) {
                    _.forEach(y[this.interStr]['origins'][c], dest => { this.addToTree(this.destinationStr, this.interIndex, dest, true); });
                }
                if (node.locationType === this.intlIndex) {
                    _.forEach(y[this.intlStr]['origins'][c], dest => { this.addToTree(this.destinationStr, this.intlIndex, dest, true); });
                }
                break;

            case 'destination':
                this.emptyTree('origin');
                if (node.locationType === this.intraIndex) {
                    _.forEach(y[this.intraStr]['destinations'][c], orig => { this.addToTree(this.originStr, this.intraIndex, orig, true); });
                }
                if (node.locationType === this.interIndex) {
                    _.forEach(y[this.interStr]['destinations'][c], orig => { this.addToTree(this.originStr, this.interIndex, orig, true); });
                }
                if (node.locationType === this.intlIndex) {
                    _.forEach(y[this.intlStr]['destinations'][c], orig => { this.addToTree(this.originStr, this.intlIndex, orig, true); });
                }
                break;

            default:
                this.emptyTree();
                _.forOwn(y[this.intraStr]['origins'], (v, k) => { this.addToTree(this.originStr, this.intraIndex, v[0], false); });
                _.forOwn(y[this.interStr]['origins'], (v, k) => { this.addToTree(this.originStr, this.interIndex, v[0], false); });
                _.forOwn(y[this.intlStr]['origins'], (v, k) => { this.addToTree(this.originStr, this.intlIndex, v[0], false); });

                _.forOwn(y[this.intraStr]['destinations'], (v, k) => { this.addToTree(this.destinationStr, this.intraIndex, v[0], false); });
                _.forOwn(y[this.interStr]['destinations'], (v, k) => { this.addToTree(this.destinationStr, this.interIndex, v[0], false); });
                _.forOwn(y[this.intlStr]['destinations'], (v, k) => { this.addToTree(this.destinationStr, this.intlIndex, v[0], false); });
                break;
        }
    }

    // deep clone of array of objects
    cloneArrayOfObjects(obj) {
        const clone = [];
        for (const i in obj) {
            if (obj[i] != null && typeof (obj[i]) == 'object') {
                clone[i] = this.cloneArrayOfObjects(obj[i]);
            } else {
                clone[i] = obj[i];
            }
        }
        return clone;
    }

    // EXPAND all nodes on a given tree
    doExpand(target: string) {
    }


    // add a node to given target (tree) and node (d.name = enum(intra, inter, international))
    plus(d: any, target: string) {
        console.log('plus', target, d);

        switch (target) {
            case this.originStr:
                this.originGroup.get('originInput').setValue('');
                this.originTree[d.index].showAddInput = true;
                break;
            case this.destinationStr:
                this.destinationGroup.get('destinationInput').setValue('');
                this.destinationTree[d.index].showAddInput = true;
                break;
            default:
        }
        d.showAddInput = true;
    }

    // remove a node from given target (tree) and node (d.id)
    minus(d: any, target: string) {
        console.log('minus', target, d);
        const tempParentIndex = d.parent.index;
        let todel;
        switch (target) {
            case this.originStr:
                todel = _.find(this.scope, {
                    'originId': d.data.scRecord.stateCountryId,
                    'destinationId': this.screenState.selectedDestination.data.scRecord.stateCountryId
                });
                this.tmssloader.show();
                this.hhgScopeService.removeCarrierScope3(todel.scopeId).subscribe(data => {
                    this.tmssloader.hide();
                    this.setMessage('Removed scope record from ' + d.data.scRecord.stateCountryName + ' to ' + this.screenState.selectedDestination.data.scRecord.stateCountryName + '.', 'success');
                    this.scope = _.reject(this.scope, todel);
                    if (!_.find(this.scope, { 'originId': todel.stateCountryOrigDetails.stateCountryId, 'scopeType': todel.scopeType })) {
                        this.loadTree();
                        this.screenState.state = this.screenState.showAll;
                        this.screenState.text = this.screenState.showingAll;
                    } else {
                        this.loadTree(this.screenState.selectedDestination.data, 'destination');
                    }
                    this.originTree[tempParentIndex].showPlus = true;
                    this.alert.success(data);
                }, error => {
                    this.tmssloader.hide();
                    this.alert.error(api_error);
                });
                break;
            case this.destinationStr:
                todel = _.find(this.scope, {
                    'originId': this.screenState.selectedOrigin.data.scRecord.stateCountryId,
                    'destinationId': d.data.scRecord.stateCountryId
                });
                this.tmssloader.show();
                this.hhgScopeService.removeCarrierScope3(todel.scopeId).subscribe(data => {
                    this.tmssloader.hide();
                    this.setMessage('Removed scope record from ' + this.screenState.selectedOrigin.data.scRecord.stateCountryName + ' to ' + d.data.scRecord.stateCountryName + '.', 'success');
                    this.scope = _.reject(this.scope, todel);
                    if (!_.find(this.scope, { 'destinationId': todel.stateCountryDestDetails.stateCountryId, 'scopeType': todel.scopeType })) {
                        this.loadTree();
                        this.screenState.state = this.screenState.showAll;
                        this.screenState.text = this.screenState.showingAll;
                    } else {
                        this.loadTree(this.screenState.selectedOrigin.data, 'origin');
                    }
                    // this.loadTree(this.screenState.selectedOrigin.data, 'origin');
                    this.destinationTree[tempParentIndex].showPlus = true;
                    this.alert.success(data);
                }, error => {
                    this.tmssloader.hide();
                    this.alert.error(api_error);
                });
                break;
            default:
                return false;
        }
    }

    generateDownload() {
        console.log('carrierId: ' + this.activeCarrier.carrierId + 'and scopeType: ' + this.scopeType);
        this.modalRef = this.modalService.show(ConfirmationModalComponent);
        this.modalRef.content.question = 'Do you want to Export ' + this.scopeType + ' TSP Scope for Carrier Id: ' + this.activeCarrier.scacName;
        this.modalRef.content.title = 'Export TSP Scope';
        this.modalRef.content.confirmText = 'Yes';
        this.modalRef.content.cancelText = 'No';
        this.modalRef.content.emitData.subscribe(result => {
            console.log('results', result.obj);
            if (result.obj === true) {
                let scopeResult: DownloadFileResponse;
                this.tmssloader.show();
                this.hhgScopeService.getScopeListXlsx(this.activeCarrier.carrierId, this.scopeType).subscribe(result => {
                    scopeResult = result as DownloadFileResponse;
                    let byteData: number[] = scopeResult.byteData;
                    let fileName: string = scopeResult.fileName;
                    let numRows: number = scopeResult.numberOfExcelRows;
                    console.log("result.numberOfExcelRows: " + result.numberOfExcelRows);
                    let bytes = new Uint8Array(byteData);
                    let blob = new Blob([bytes], {
                        type: null
                    });
                    console.log("numRows: " + numRows)
                    if (numRows !== 0) {
                        //SAVE EXCEL FILE
                        FileSaver.saveAs(blob, fileName);
                        this.alert.success("Scope List Report created - " + numRows + " Records found");
                    } else {
                        this.alert.success("No records found for selected options");
                    }
                    this.tmssloader.hide();
                }, (error) => {
                    this.alert.error(error);
                    console.log('Error.......... ', error);
                    this.tmssloader.hide();
                }, () => {
                });
            }
        });
    }
}
